export default "__VITE_ASSET__d7703725__"